import { render } from "./NftDetailModal.vue?vue&type=template&id=49308916"
import script from "./NftDetailModal.vue?vue&type=script&lang=js"
export * from "./NftDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__